var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfvIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_110",
    "data-name": "Rectangle 110",
    width: 85.506,
    height: 68.966,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2002",
    "data-name": "Group 2002",
    transform: "translate(-376.75 -1439)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_202",
    "data-name": "Rectangle 202",
    width: 130,
    height: 130,
    rx: 65,
    transform: "translate(506.75 1569) rotate(180)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1982",
    "data-name": "Group 1982",
    transform: "translate(399.247 1469.517)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1759",
    "data-name": "Group 1759",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M81.358,18.641,76.609,23.39a1.724,1.724,0,0,1-2.436,0l-15.7-15.7a1.722,1.722,0,0,1,0-2.436L63.222.5a1.722,1.722,0,0,1,2.436,0l15.7,15.7a1.722,1.722,0,0,1,0,2.436",
    transform: "translate(3.643 0)",
    fill: "#00bcee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M72.718,28.628l-8.81,8.467a2.211,2.211,0,0,1-3.073-.007L43.282,20.061a5.225,5.225,0,0,0-3.828-1.471l-1.128.04a5.227,5.227,0,0,0-4.486,2.886l-3.275,6.55a5.227,5.227,0,0,1-9.358-4.657l6.512-13.143A10.515,10.515,0,0,1,39.736,4.743l15.1,3.846A5.224,5.224,0,0,1,57.24,9.959l15.51,15.51a2.212,2.212,0,0,1-.032,3.159",
    transform: "translate(1.299 0.278)",
    fill: "#00bcee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M36.4,54.765a4,4,0,0,0-5.393-.5c-.038.03-.08-.012-.05-.05a4,4,0,0,0-5.6-5.614.037.037,0,0,1-.052-.053,4,4,0,0,0-5.614-5.6c-.039.03-.08-.012-.05-.051a4,4,0,0,0-.5-5.393,4.181,4.181,0,0,0-5.705.321l-4.2,4.2a4.182,4.182,0,0,0-.32,5.706,4,4,0,0,0,5.393.5c.039-.03.08.011.05.05a4,4,0,0,0,5.6,5.614.037.037,0,0,1,.052.052,4,4,0,0,0,5.614,5.6c.039-.03.081.012.051.051a4,4,0,0,0,.5,5.392,4.18,4.18,0,0,0,5.705-.32l4.2-4.2a4.182,4.182,0,0,0,.32-5.706",
    transform: "translate(0.499 2.296)",
    fill: "#00bcee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    d: "M63.9,41.867l-2.221-2.221-.755.755,2.221,2.221A3.473,3.473,0,0,1,58.3,47.6a.282.282,0,0,0-.053-.064l-2.221-2.221-7.5-7.493-.744.744-.011.011,7.493,7.493,2.221,2.221a.687.687,0,0,0,.1.085,3.474,3.474,0,0,1-4.91,4.91.688.688,0,0,0-.085-.1l-2.221-2.221-7.493-7.493h-.011l-.744.744-.011.011,7.5,7.493,2.221,2.221h.011l.053.053a3.446,3.446,0,0,1,.957,2.4,3.484,3.484,0,0,1-1.01,2.455,3.56,3.56,0,0,1-4.8.106,1.162,1.162,0,0,0-.106-.117L44.7,56.62l-7.493-7.493-.011.011-.744.744-.011.011,7.493,7.493,2.221,2.221a.416.416,0,0,0,.106.085,3.468,3.468,0,0,1,.925,2.36,3.432,3.432,0,0,1-1.02,2.455,3.543,3.543,0,0,1-4.91,0l-2.221-2.221-.755.755L40.5,65.261a4.54,4.54,0,0,0,7.557-4.517,4.472,4.472,0,0,0,1.307.191,4.551,4.551,0,0,0,4.347-5.856,4.6,4.6,0,0,0,1.318.191,4.53,4.53,0,0,0,4.336-5.856,4.314,4.314,0,0,0,1.318.2,4.538,4.538,0,0,0,3.21-7.748",
    transform: "translate(2.29 2.377)",
    fill: "#00bcee"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_30",
    "data-name": "Line 30",
    x2: 11.549,
    y2: 11.549,
    transform: "translate(0.376 25.437)",
    fill: "none",
    stroke: "#00bcee",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfvIcon);
export default __webpack_public_path__ + "static/media/Ofv-icon.85a70ef0074abf24739551c3bb069541.svg";
export { ForwardRef as ReactComponent };